import { useState } from "react";
import { Link } from "react-router";

const EMERALD = "#10B981";

const NAV_LINKS = [
    { label: "Servicios", to: "#services" },
    { label: "Cómo Funciona", to: "#how-it-works" },
    { label: "Nosotros", to: "#about" },
    { label: "Contacto", to: "#contact" },
];

export default function HeyVetHeaderComponent() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="hv-header">
            <div className="hv-container" style={{ height: 70, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                {/* Logo */}
                <Link to="/e7b3a1f2-8c4d-4f5e-9a6b-2d1c3e4f5a6b" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", flexShrink: 0 }}>
                    <span className="material-symbols-outlined" style={{ color: EMERALD, fontSize: 32 }}>pets</span>
                    <span style={{ fontSize: "1.4rem", fontWeight: 800, color: "#0F172A", fontFamily: "'Poppins', sans-serif" }}>
                        Hey<span style={{ color: EMERALD }}>Vet</span>
                    </span>
                </Link>

                {/* Nav — desktop */}
                <nav style={{ display: "flex", gap: 8 }} className="hv-header-nav">
                    {NAV_LINKS.map(({ label, to }) => (
                        <a
                            key={label}
                            href={to}
                            className="hv-nav-link"
                            style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: "0.95rem" }}
                        >
                            {label}
                        </a>
                    ))}
                </nav>

                {/* CTA button — desktop */}
                <div className="hv-header-cta" style={{ display: "flex", alignItems: "center" }}>
                    <button className="hv-btn hv-btn-primary">
                        Agendar Cita
                    </button>
                </div>

                {/* Hamburger — mobile */}
                <button
                    className="hv-hamburger"
                    onClick={() => setMenuOpen(!menuOpen)}
                    style={{ display: "none", background: "none", border: "none", cursor: "pointer", padding: 8 }}
                    aria-label="Menú"
                >
                    <span style={{ display: "block", width: 24, height: 2, background: "#0F172A", margin: "5px 0", transition: "all .2s" }} />
                    <span style={{ display: "block", width: 24, height: 2, background: "#0F172A", margin: "5px 0", transition: "all .2s" }} />
                    <span style={{ display: "block", width: 24, height: 2, background: "#0F172A", margin: "5px 0", transition: "all .2s" }} />
                </button>
            </div>

            {/* Mobile drawer */}
            {menuOpen && (
                <div style={{ background: "white", padding: "16px 24px", borderTop: "1px solid #F1F5F9" }}>
                    {NAV_LINKS.map(({ label, to }) => (
                        <a
                            key={label}
                            href={to}
                            onClick={() => setMenuOpen(false)}
                            style={{ display: "block", color: "#475569", fontFamily: "'Nunito Sans',sans-serif", fontWeight: 600, fontSize: "1rem", padding: "12px 0", textDecoration: "none", borderBottom: "1px solid #F1F5F9" }}
                        >
                            {label}
                        </a>
                    ))}
                    <div style={{ paddingTop: 16 }}>
                        <button className="hv-btn hv-btn-primary" style={{ width: "100%" }}>
                            Agendar Cita
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
